export default "__VITE_ASSET__Do8m6n8L__"